import { CostLineType, JobCostingLine } from "../types/costing.types";

export const isSupplierBillableLine = (line: Pick<JobCostingLine, "line_type" | "is_supplier_billed" | "supplier_bill_id">): boolean =>
  (line.line_type === CostLineType.COST || line.line_type === CostLineType.DISBURSEMENT) &&
  !Number(line.is_supplier_billed) && !line.supplier_bill_id;

export const isCostingLineLocked = (line: Pick<JobCostingLine, "is_invoiced" | "is_supplier_billed">): boolean =>
  Boolean(Number(line.is_invoiced) || Number(line.is_supplier_billed));
